import React from 'react';
import { SearchTabsProvider } from '../../contexts/SearchTabsContext';
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext';
import Sidebar from './Sidebar';
import MobileMenuButton from './MobileMenuButton';

const DashboardLayoutContent = ({ children, contentBackground = "bg-white dark:bg-tw-neutral-50", showMobileHeader = true }) => {
  const { isSidebarOpen, closeSidebar } = useSidebar();

  return (
    <div className="h-screen bg-white dark:bg-tw-neutral-900 flex">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      {/* Main Content Area */}
      <div className={`flex-1 flex flex-col overflow-y-scroll ${contentBackground}`}>
        {/* Mobile Header with Hamburger - Hidden on pages that have their own */}
        {showMobileHeader && (
          <div className="lg:hidden sticky top-0 z-30 px-4 py-3">
            <MobileMenuButton className="!bg-white !text-tw-neutral-900" />
          </div>
        )}
        
        {children}
      </div>
    </div>
  );
};

const DashboardLayout = ({ children, contentBackground, showMobileHeader }) => (
  <SidebarProvider>
  <SearchTabsProvider>
      <DashboardLayoutContent contentBackground={contentBackground} showMobileHeader={showMobileHeader}>
        {children}
      </DashboardLayoutContent>
  </SearchTabsProvider>
  </SidebarProvider>
);

export default DashboardLayout;